import { useSelector } from "react-redux";
import { selectMechanicId } from "../redux/mechanic";

function MechanicBasedView(props) {
  const { children } = props;

  const selectedMechanicId = useSelector(selectMechanicId);

  if (!selectedMechanicId) {
    return null;
  }

  return children;
}

export default MechanicBasedView;
